import { initialState } from "../upsells.slice";

const resetUpsells = () => {
    return initialState;
}

export default resetUpsells;